// extracted by mini-css-extract-plugin
export default {"form":"Subscription_form__v2Bl6","wrap":"Subscription_wrap__1wo4G","button":"Subscription_button__kswIZ"};